import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"

const PW_RULES = [
    { label: "Au moins 14 caractères", test: (p) => p.length >= 14 },
    { label: "Au moins une minuscule et une majuscule", test: (p) => /[a-z]/.test(p) && /[A-Z]/.test(p) },
    { label: "Au moins un chiffre", test: (p) => /[0-9]/.test(p) },
    { label: "Au minimum un symbole (!?&#$*)", test: (p) => /[^A-Za-z0-9\s]/.test(p) },
]

const useStyles = makeStyles({
    container: { width: "100%", marginTop: 6 },
    head: { fontSize: 14, lineHeight: "22px", color: "#555555", marginBottom: 10 },
    rule: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 14,
        lineHeight: "22px",
        marginBottom: 6,
        transition: "color 300ms",
    },
    icon: { fontSize: 16, flexShrink: 0 },
    neutral: { color: "#555555" },
    valid: { color: "#368F50" },
    error: { color: "#F44259" },
})

const LoginChecklist = ({ password = "", touched = false }) => {
    const classes = useStyles()
    const hasRepeat = /(.)\1\1/.test(password)

    return (
        <div className={classes.container}>
            <div className={classes.head}>Votre mot de passe doit contenir :</div>
            {PW_RULES.map((rule, i) => {
                const ok = rule.test(password)
                const showRed = touched && password.length > 0 && !hasRepeat && !ok
                const state = ok ? "valid" : showRed ? "error" : "neutral"
                return (
                    <div key={i} className={`${classes.rule} ${classes[state]}`}>
                        {state === "error"
                            ? <CloseIcon className={classes.icon} />
                            : <CheckIcon className={classes.icon} />
                        }
                        {rule.label}
                    </div>
                )
            })}
        </div>
    )
}

export default LoginChecklist
